import React, { useEffect, useState } from "react";
// import logo from "../Assets/Montra new logo.png";
import curve from "../Assets/curve1.png";
import curve2 from "../Assets/curve2.png";
import dot from "../Assets/dot.png";
import wave from "../Assets/wave.png";
import bsa from "../Assets/BSA_Logo.png";
import montra from "../Assets/Montra new logo.png";
import machCity from "../Assets/Machcity_Logo.png";
import trackAndTrail from "../Assets/trackandtrail_newlogo.png";
import hercules from "../Assets/Hercules_Web_Logo.png";
import herculesFitness from "../Assets/herculesfitnesslogo.png";
import { formatDate } from "../utils/function";

const warrantyData = [
  {
    id: 1,
    warrantyNumber: "ABC001",
    name: "Steve Harrington",
    productName: "Cycle",
    brand: "BSA",
    frameNumber: "789-45-632",
    wowNumber: "7891-4567-6321",
    dateofPurchase: "01-01-2025",
    warrantyStartdate: "01-01-2025",
    warrantyEnddate: "01-01-2027",
    brandwebsite: "Montra",
    brandLogo: "https://via.placeholder.com/80x40",
    qrCode: "https://via.placeholder.com/100",
    warrantyBadge: "https://via.placeholder.com/100x50",
  },
];

const WarrCard = ({ selectedWarranty, createdFromBrand }) => {
  const [image, setImage] = useState();
  //   let warrantyEndDate = new Date(selectedWarranty?.purchaseDate);
  //   let newDate = new Date()

  //   newDate
  //   warrantyData.addDays()

  useEffect(() => {
    if (!createdFromBrand) return;

    const brand = createdFromBrand.toLowerCase();
    let selectedImage = null;

    switch (brand) {
      case "trackandtrail":
        selectedImage = trackAndTrail;
        break;
      case "bsa":
        selectedImage = bsa;
        break;
      case "montra":
        selectedImage = montra;
        break;
      case "machcity":
        selectedImage = machCity;
        break;
      case "hercules":
        selectedImage = hercules;
        break;
      case "herculesfitness":
        selectedImage = herculesFitness;
        break;
      default:
        selectedImage = null;
    }

    setImage(selectedImage);
  }, [createdFromBrand]);

  return (
    <div className="relative w-full p-4">
      {warrantyData.map((data) => (
        <div
          key={data.id}
          className="relative border rounded-lg shadow-md p-4 h-auto"
        >
          <div className="flex flex-col">
            <div className="relative flex items-center justify-between">
              <img
                src={image}
                alt="Brand Logo"
                className="w-[180px] h-auto z-10"
              />
              <img
                src={curve}
                alt="sidecurve"
                className="absolute w-[250px] h-auto -right-[17px] -top-4 rounded-tr-lg -z-0"
              />
              <div>
                <div className="relative text-[20px] font-bold text-black-500">
                  WARRANTY <span className="text-gray-400">CARD</span>
                </div>
              </div>
            </div>
            <div className="z-10">
              <p className=" text-[10px] mt-2">
                Thank you for beginning this journey with Track and Trail. Our
                products are thoughtfully designed with your needs in mind,
                enabling you to live a fuller and more empowered life. This
                product is covered by warranty from the date of purchase against
                manufacturing defects. Please note that the warranty does not
                cover misuse, physical damage, or water ingress.
              </p>
            </div>
          </div>
          <div className="flex flex-row w-full leading-8">
            <div className="mt-3 text-[14px] w-full z-10">
              <p>
                <span className="font-medium">Warranty Number:</span>{" "}
                {selectedWarranty?.frameNo}
              </p>
              <p>
                <span className="font-medium">Name:</span>{" "}
                {selectedWarranty?.warrantyFormID?.name ||
                  selectedWarranty?.name}
              </p>
              <p>
                <span className="font-medium">Product Name:</span>{" "}
                {selectedWarranty?.warrantyFormID?.productName ||
                  selectedWarranty?.productName}
              </p>
              <p>
                <span className="font-medium">Brand:</span>{" "}
                {selectedWarranty?.brand ||
                  selectedWarranty?.warrantyFormID?.brand}
              </p>
              <p>
                <span className="font-medium">Frame Number:</span>{" "}
                {selectedWarranty?.frameNo}
              </p>
              {selectedWarranty?.wowNo && (
                <p>
                  <span className="font-medium">WOW Number:</span>{" "}
                  {selectedWarranty?.wowNo}
                </p>
              )}

              {/* MM - DD - YYYY */}
              <p>
                <span className="font-medium">Date of Purchase:</span>{" "}
                {formatDate(selectedWarranty?.purchaseDate)}
              </p>
              <p>
                <span className="font-medium">Warranty Start Date:</span>
                {formatDate(selectedWarranty?.purchaseDate)}
              </p>
              <p>
                <span className="font-medium">Warranty End Date:</span>{" "}
                {formatDate(selectedWarranty?.purchaseDate, 2)}
              </p>
              <p>
                <span className="font-medium">Brand Website:</span>{" "}
                {selectedWarranty?.brand ||
                  selectedWarranty?.warrantyFormID?.brand}
              </p>
            </div>
          </div>
          <img
            src={curve2}
            alt=""
            className="absolute w-[250px] h-auto left-0 bottom-0 rounded-tr-lg bg-right z-0"
          />
          <img
            src={dot}
            alt=""
            className="absolute w-[100px] h-auto right-[50px] bottom-4 rounded-tr-lg -z-0"
          />
          <img
            src={wave}
            alt=""
            className="absolute w-[325px] h-auto right-[0px] bottom-0 rounded-tr-lg -z-0"
          />
          <div className="relative mt-6 flex justify-center">
            <p className="text-[11px]">
              Our commitment to quality extends to our service as well. If,
              contrary to expectations, you experience any issues with the
              product, please contact Track and Trail After-Sales Support at
              1800-102-2324 or submit the claim form along with this warranty
              card and the original payment receipt. Alternatively, you can
              write to us at{" "}
              <a href="mailto:customercare@trackandtrail.in">
                customercare@trackandtrail.in
              </a>
              ,<br />
              <a href="mailto:customercare@bsahercules.com">
                customercare@bsahercules.com
              </a>
              .
            </p>
          </div>
          <div>
            <h4 className="text-[10px]">
              Track and Trail reserves the right to either repair or replace the
              item at its discretion.
            </h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WarrCard;
